import AsyncLoader from 'component/AsyncLoader';

export const RoleManage =  AsyncLoader(() => import('./RoleManage'));
export const UserManage =  AsyncLoader(() => import('./UserManage'));